import { App, Button, Card, Col, Input, message, Modal,Pagination, Row, Select, Space, Spin, Table, Tag, Popconfirm, Tooltip } from "antd";
import { EyeFilled, LoadingOutlined, LockOutlined, CloseOutlined, CheckOutlined } from "@ant-design/icons";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SUB_ADMIN_LIST, SUB_ADMIN_STATUS, CHANGE_LEARNER_PASSWORD,} from "../../apis/apis";
import debounce from "lodash.debounce";
import CulsightPageLoader from "../../components/CulsightPageLoader";
import { formatToIST } from "../../../helper/CommonHelper";



function SubAdmin() {
    const { notification } = App.useApp();
    const [page_size, set_page_size] = useState(10);
    //USE STATE FOR PAGINATION AND LOADER
    const navigate = useNavigate();
    const [loader, setLoader] = useState(true);
    const [pagination_loader, set_pagination_loader] = useState(false);
    const [table_data, set_table_data] = useState(false);
    const [current_page, set_current_page] = useState("");
    const [total_pages, set_total_pages] = useState("");
    const [total_learners, set_total_learners] = useState("");
    const [onchange_call, set_onchange_call] = useState(true);
 
    // fillter state
    const [placeholder, set_placeholder] = useState("Search by name");
    const [search_query_key, set_search_query_key] = useState('name');
    const [search_query_value, set_search_query_value] = useState('');
   
  


    // ✅ CHANGE PASSWORD STATES
    const [changePasswordModal, setChangePasswordModal] = useState(false);
    const [passwordEmail, setPasswordEmail] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordLoading, setPasswordLoading] = useState(false);
    const [passwordErrors, setPasswordErrors] = useState({});




    const handleUpdatePassword = async () => {
        setPasswordErrors({});

        try {
            setPasswordLoading(true);

            const formData = new FormData();
            formData.append("email", passwordEmail);
            formData.append("new_password", newPassword);
            formData.append("confirm_password", confirmPassword);

            const response = await CHANGE_LEARNER_PASSWORD(formData);

            if (response?.data?.status) {
                notification.success({
                    message: "Success",
                    description: response.data.message,
                });

                setChangePasswordModal(false);
                setNewPassword("");
                setConfirmPassword("");
                setPasswordErrors({});
            } else {
                // ✅ status false but 200 response
                setPasswordErrors(response?.data?.errors || {});
            }
        } catch (error) {
            // ✅ 400 / 422 backend validation
            if (error?.response?.data?.errors) {
                setPasswordErrors(error.response.data.errors);
            } else {
                notification.error({
                    message: "Server Error",
                    description: "Something went wrong",
                });
            }
        } finally {
            setPasswordLoading(false);
        }
    };


   
   


    const fetchResults = useCallback((search_key, search_value) => {
        debounce(async () => {
            try {
                set_pagination_loader(true);
                const FORM_DATA = new FormData();
                FORM_DATA.append(search_key, search_value);
                const API_CALL = await SUB_ADMIN_LIST(FORM_DATA);
                if (API_CALL?.data?.status) {
                    set_table_data(API_CALL?.data?.data);
                    set_current_page(API_CALL?.data?.current_page);
                    set_total_pages(API_CALL?.data?.total_pages);
                    set_total_learners(API_CALL?.data?.total_learners);
                }
            } catch (err) {
                console.error("API Error:", err);
            } finally {
                set_pagination_loader(false);
            }
        }, 500)(); // Call debounce immediately
    }, []);



    const LIST_API = async () => {
        const FORM_DATA = new FormData();
        const API_CALL = await SUB_ADMIN_LIST(FORM_DATA);
        if (API_CALL?.data?.status) {
            set_table_data(API_CALL?.data?.data);
            set_current_page(API_CALL?.data?.current_page);
            set_total_pages(API_CALL?.data?.total_pages);
            set_total_learners(API_CALL?.data?.total_learners);
            setLoader(false);
        } else {
            console.log("error");
            setLoader(false);
        }
    };

    useEffect(() => {
        LIST_API();
    }, [onchange_call]);

    const change_status = async (id) => {
        setLoader(true);
        const FORM_DATA = new FormData();
        FORM_DATA.append("id", id);
        try {
            const response = await SUB_ADMIN_STATUS(FORM_DATA);
            if (response?.data?.status) {
                notification.success({
                    message: "Successful",
                    description: response?.data?.message,
                });
                set_onchange_call(onchange_call ? false : true)

            } else {
                // setLoader(false);

            }
        } catch (error) {
            message.error(
                "Server Error: " + (error?.response?.data?.message || "Unknown error")
            );
        }
    };

    const selectBefore = (
        <Select defaultValue="Name" onChange={(value) => {
            if (value === 'Name') {
                set_search_query_key('name')
                set_placeholder("Search by name");
                fetchResults('name', search_query_value)
            }
            if (value === 'Email') {
                set_search_query_key('email')
                set_placeholder("Search by email");
                fetchResults('email', search_query_value)
            }
            if (value === 'Phone') {
                set_search_query_key('contact_no')
                set_placeholder("Search by contact no.");
                fetchResults('contact_no', search_query_value)
            }
        }}>
            <Select.Option value="Name">Name</Select.Option>
            <Select.Option value="Email">Email</Select.Option>
            <Select.Option value="Phone">Phone</Select.Option>
        </Select>
    );

    const columns = [
        {
            title: "Name",
            dataIndex: "name",
            render: (text, record) => (
                <span>
                    {record.first_name} {record.last_name}
                </span>
            ),
        },
        {
            title: "Email",
            dataIndex: "email",
            render: (text, record) => <span>{record.email}</span>,
        },
        {
            title: "Phone",
            dataIndex: "contact_no",
            render: (text, record) => <span>{record.contact_no}</span>,
        },
        {
            title: "Last Login",
            dataIndex: "last_login",
            render: (text, record) => (
                <div>
                    {record.last_login ? <>
                        <div style={{ fontSize: "12px", }}>{formatToIST(record.last_login)}</div>

                    </> : <><div style={{ color: "#5bede7" }}>Not login yet</div></>}

                </div>
            ),
        },
        {
            title: "Joined On",
            key: "joining_on",
            render: (text, record) => (
                <div>
                    <div style={{ fontSize: "12px" }}>{formatToIST(record.joining_on)}</div>

                </div>
            ),
        },
        {
            title: "Status",
            key: "status",
            render: (text, record) => (
                <span>
                    {record.status ? (
                        <>
                            <Tag color="success">Active</Tag>
                        </>
                    ) : (
                        <>
                            <Tag color="error">Inactive</Tag>
                        </>
                    )}
                </span>
            ),
        },
        {
            title: "Action",
            key: "action",
            render: (_, record) => (
                <Space size="middle">
                    <Button type="primary" size="small" onClick={() => navigate("/edit-sub-admin/" + btoa(record.id))}><EyeFilled /></Button>
                    <Tooltip title="Change Password">
                        <Button
                            size="small"
                            onClick={() => {
                                setPasswordEmail(record.email);
                                setChangePasswordModal(true);
                            }}
                            style={{ backgroundColor: 'green', borderColor: 'green', color: 'white' }}
                        >
                            <LockOutlined />
                        </Button>
                    </Tooltip>



                    <Popconfirm
                        title="Do you want to change the status?"
                        onConfirm={() => change_status(record?.id)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Tooltip title="Change Status">
                            <Button
                                size="small"
                                style={{
                                    backgroundColor: record.status ? "#52c41a" : "#ff4d4f",
                                    borderColor: record.status ? "#52c41a" : "#ff4d4f",
                                    color: "#fff"
                                }}
                                icon={
                                    record.status ? (
                                        <CheckOutlined />
                                    ) : (
                                        <CloseOutlined />
                                    )
                                }
                            />
                        </Tooltip>
                    </Popconfirm>

                </Space>
            ),
        },
    ];

    const pagination_on_change = async (page, size) => {
        set_pagination_loader(true);
        const FORM_DATA = new FormData();
        FORM_DATA.append("page", page);
        FORM_DATA.append("per_page", size);
        FORM_DATA.append(search_query_key, search_query_value);
        const API_CALL = await SUB_ADMIN_LIST(FORM_DATA);
        if (API_CALL?.data?.status) {
            set_table_data(API_CALL?.data?.data);
            set_current_page(API_CALL?.data?.current_page);
            set_total_pages(API_CALL?.data?.total_pages);
            set_total_learners(API_CALL?.data?.total_learners);
            set_pagination_loader(false);
        } else {
            set_pagination_loader(false);
        }
    }

    const handleInput = (e) => {
        const value = e.target.value;
        set_search_query_value(value)

        if (search_query_key === 'name') {
            fetchResults('name', value)
        }
        if (search_query_key === 'email') {
            fetchResults('email', value)
        }
        if (search_query_key === 'contact_no') {
            fetchResults('contact_no', value)
        }
    };


  


    return (
        <div className="lms-body">
            <Card>
                <Row>
                    <Col span={12}>
                        <h2>Sub Admin</h2>
                    </Col>
                    <Col span={12}>
                        <div className="learner-buttons" style={{ float: "right" }}>
                            <Button
                                color="green"
                                variant="solid"
                                style={{ marginRight: "10px" }}
                                onClick={() => navigate("/add-sub-admin")}
                            >
                                Add Sub Admin
                            </Button>
                            {/* <Button
                color="danger"
                variant="solid"
                style={{ marginRight: "3px" }}
              >
                Export Learner
              </Button> */}
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col span={12}>
                        <Input
                            addonBefore={selectBefore}
                            placeholder={placeholder}
                            onChange={handleInput}
                            size="large"
                        />
                    </Col>
                </Row>

                {loader ? (
                    <>
                        <CulsightPageLoader />
                    </>
                ) : (
                    <>
                        {pagination_loader ? (
                            <>
                                <div style={{ textAlign: "center", padding: "60px" }}>
                                    <Spin indicator={<LoadingOutlined spin />} size="large" />
                                </div>
                            </>
                        ) : (
                            <>
                                <Table
                                    columns={columns}
                                    pagination={false}
                                    dataSource={table_data}
                                    style={{ marginTop: "15px" }}
                                    rowKey="id"
                                />
                            </>
                        )}

                        {total_pages > 0 ? (
                            <>
                                <div style={{ float: "right", marginTop: "20px" }}>
                                    {" "}
                                    <Pagination
                                        current={current_page}
                                        total={total_learners}
                                        pageSize={page_size}
                                        showSizeChanger
                                        pageSizeOptions={['10', '20', '50', '100']}
                                        onChange={(page) => pagination_on_change(page, page_size)}
                                        onShowSizeChange={(page, size) => {
                                            set_page_size(size);
                                            pagination_on_change(1, size);
                                        }}
                                        style={{ display: 'inline-block' }}
                                        className="no-search-pagination"
                                    />

                                    <style>
                                        {`
    .no-search-pagination .ant-select-selection-search-input {
      display: none !important;
    }
  `}
                                    </style>
                                </div>
                            </>
                        ) : (
                            <>
                               
                            </>
                        )}
                    </>
                )}
                <Modal
                    title="Change Password"
                    open={changePasswordModal}
                    onCancel={() => {
                        setChangePasswordModal(false);
                        setNewPassword("");
                        setConfirmPassword("");
                        setPasswordErrors({});
                    }}
                    footer={[
                        <Button
                            type="primary"
                            loading={passwordLoading}
                            onClick={handleUpdatePassword}
                            style={{ width: "100%" }}
                        >
                            Update Password
                        </Button>
                    ]}
                >
                    {/* 🔹 NEW PASSWORD */}
                    <div style={{ fontSize: "14px", fontWeight: 500, marginBottom: "4px" }}>
                        New Password
                    </div>
                    <Input.Password
                        placeholder="New Password"
                        value={newPassword}
                        onChange={(e) => {
                            setNewPassword(e.target.value);
                            setPasswordErrors((prev) => ({ ...prev, new_password: "" }));
                        }}
                    />
                    {passwordErrors?.new_password && (
                        <div style={{ color: "red", fontSize: "12px", marginBottom: "8px" }}>
                            {passwordErrors.new_password}
                        </div>
                    )}

                    {/* 🔹 CONFIRM PASSWORD */}
                    <div style={{ fontSize: "14px", fontWeight: 500, marginBottom: "4px" }}>
                        Confirm Password
                    </div>
                    <Input.Password
                        placeholder="Confirm Password"
                        value={confirmPassword}
                        onChange={(e) => {
                            setConfirmPassword(e.target.value);
                            setPasswordErrors((prev) => ({ ...prev, confirm_password: "" }));
                        }}
                    />
                    {passwordErrors?.confirm_password && (
                        <div style={{ color: "red", fontSize: "12px" }}>
                            {passwordErrors.confirm_password}
                        </div>
                    )}
                </Modal>


            </Card>
        </div>
    );
}

export default SubAdmin;
